var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "ci-content-hub-tile bg-white",
      on: { click: _vm.handleClick },
    },
    [
      _c("div", { staticClass: "row m-0 py-3" }, [
        _c("p", {
          staticClass: "font-weight-semi tag-name py-2 pl-3 pr-5 m-0",
          domProps: { textContent: _vm._s(_vm.tags[_vm.tags.length - 1].name) },
        }),
      ]),
      _c("div", { staticClass: "tile-info row m-0 px-4 pb-4" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h5", {
            staticClass: "title pb-3 h5",
            domProps: { textContent: _vm._s(_vm.contentHub.title) },
          }),
          _c("p", {
            staticClass: "teaser",
            domProps: { textContent: _vm._s(_vm.contentHub.teaser) },
          }),
          _c("div", { staticClass: "row m-0 mt-auto" }, [
            _c("div", { staticClass: "mr-4" }, [
              _c("div", { staticClass: "mdi mdi-calendar-blank mr-1" }),
              _c("time", {
                directives: [
                  {
                    name: "ci-format-date",
                    rawName: "v-ci-format-date",
                    value: {
                      value: _vm.contentHub.publication_date,
                      opts: {
                        year: "2-digit",
                        month: "2-digit",
                        day: "2-digit",
                      },
                    },
                    expression:
                      "{ value: contentHub.publication_date, opts: { year: '2-digit', month: '2-digit', day: '2-digit' } }",
                  },
                ],
              }),
            ]),
            _c("div", { staticClass: "mr-4" }, [
              _c("div", { staticClass: "mdi mdi-timer-outline mr-1" }),
              _c("span", {
                domProps: {
                  textContent: _vm._s(
                    _vm.$tc(
                      "ui.shared.global.minutes.abbr",
                      _vm.contentHub.reading_minutes
                    )
                  ),
                },
              }),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }